import React from 'react';
import { makeStyles, Icons } from '~/lib/bn-material-ui';
import baseStyles from './base-styles';
import { Trans } from '~/translations';

const useStyles = makeStyles((theme) =>
  baseStyles(theme.palette.yellow[10], theme.palette.yellow[20]),
);

export default function Unmonitored() {
  const styles = useStyles();
  return (
    <div className={styles.bar}>
      <Icons.PortableWifiOff className={styles.icon} />
      <span>
        <Trans
          i18nKey='bnCommonComponents.unmonitoredBannerText'
          components={{
            strong: <strong />,
          }}
        />
      </span>
    </div>
  );
}
